/** Agent settings — agent-only keys for non-English locales */
export const panelAgentSettingsByLang = {
  es: {
    'agent.page.settings': 'Ajustes',
    'agent.settings.profile.sponsorLabel': 'Agente patrocinador',
    'agent.settings.profile.sponsorHelp': 'Establecido en el registro',
    'agent.settings.profile.suspended': 'Suspendido',
    'agent.profile.cropPhotoTitle': 'Recortar foto de agente',
  },
  de: {
    'agent.page.settings': 'Einstellungen',
    'agent.settings.profile.sponsorLabel': 'Sponsor-Agent',
    'agent.settings.profile.sponsorHelp': 'Bei der Registrierung festgelegt',
    'agent.settings.profile.suspended': 'Gesperrt',
    'agent.profile.cropPhotoTitle': 'Agentenfoto zuschneiden',
  },
  fr: {
    'agent.page.settings': 'Paramètres',
    'agent.settings.profile.sponsorLabel': 'Agent parrain',
    'agent.settings.profile.sponsorHelp': 'Défini à l’inscription',
    'agent.settings.profile.suspended': 'Suspendu',
    'agent.profile.cropPhotoTitle': 'Recadrer la photo agent',
  },
  ar: {
    'agent.page.settings': 'الإعدادات',
    'agent.settings.profile.sponsorLabel': 'الوكيل الراعي',
    'agent.settings.profile.sponsorHelp': 'يُحدَّد عند التسجيل',
    'agent.settings.profile.suspended': 'موقوف',
    'agent.profile.cropPhotoTitle': 'قص صورة الوكيل',
  },
  ja: {
    'agent.page.settings': '設定',
    'agent.settings.profile.sponsorLabel': 'スポンサーエージェント',
    'agent.settings.profile.sponsorHelp': '登録時に設定',
    'agent.settings.profile.suspended': '停止中',
    'agent.profile.cropPhotoTitle': 'エージェント写真を切り抜く',
  },
  ko: {
    'agent.page.settings': '설정',
    'agent.settings.profile.sponsorLabel': '스폰서 에이전트',
    'agent.settings.profile.sponsorHelp': '가입 시 설정됨',
    'agent.settings.profile.suspended': '정지됨',
    'agent.profile.cropPhotoTitle': '에이전트 사진 자르기',
  },
  'zh-CN': {
    'agent.page.settings': '设置',
    'agent.settings.profile.sponsorLabel': '推荐代理',
    'agent.settings.profile.sponsorHelp': '注册时设定',
    'agent.settings.profile.suspended': '已暂停',
    'agent.profile.cropPhotoTitle': '裁剪代理照片',
  },
  pt: {
    'agent.page.settings': 'Configurações',
    'agent.settings.profile.sponsorLabel': 'Agente patrocinador',
    'agent.settings.profile.sponsorHelp': 'Definido no cadastro',
    'agent.settings.profile.suspended': 'Suspenso',
    'agent.profile.cropPhotoTitle': 'Recortar foto do agente',
  },
  it: {
    'agent.page.settings': 'Impostazioni',
    'agent.settings.profile.sponsorLabel': 'Agente sponsor',
    'agent.settings.profile.sponsorHelp': 'Impostato alla registrazione',
    'agent.settings.profile.suspended': 'Sospeso',
    'agent.profile.cropPhotoTitle': 'Ritaglia foto agente',
  },
  ru: {
    'agent.page.settings': 'Настройки',
    'agent.settings.profile.sponsorLabel': 'Спонсор-агент',
    'agent.settings.profile.sponsorHelp': 'Указывается при регистрации',
    'agent.settings.profile.suspended': 'Приостановлен',
    'agent.profile.cropPhotoTitle': 'Обрезать фото агента',
  },
  bn: {
    'agent.page.settings': 'সেটিংস',
    'agent.settings.profile.sponsorLabel': 'স্পনসর এজেন্ট',
    'agent.settings.profile.sponsorHelp': 'নিবন্ধনের সময় নির্ধারিত',
    'agent.settings.profile.suspended': 'স্থগিত',
    'agent.profile.cropPhotoTitle': 'এজেন্ট ছবি ক্রপ করুন',
  },
  hi: {
    'agent.page.settings': 'सेटिंग्स',
    'agent.settings.profile.sponsorLabel': 'प्रायोजक एजेंट',
    'agent.settings.profile.sponsorHelp': 'पंजीकरण पर सेट',
    'agent.settings.profile.suspended': 'निलंबित',
    'agent.profile.cropPhotoTitle': 'एजेंट फ़ोटो क्रॉप करें',
  },
};
